var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgNotificationInactive = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M21 18.2H3v-1.8h.9v-6.272C3.9 5.638 7.527 2 12 2s8.1 3.639 8.1 8.128V16.4h.9zM5.7 16.4h12.6v-6.272C18.3 6.633 15.48 3.8 12 3.8s-6.3 2.833-6.3 6.328zm4.05 2.7h4.5a2.25 2.25 0 0 1-4.5 0"
})));
export default SvgNotificationInactive;